"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = __importStar(require("react"));

const styled_components_1 = __importDefault(require("styled-components"));

const Portal_1 = __importDefault(require("../portal/Portal"));

const Column_1 = __importDefault(require("../column/Column"));

const useDialog_1 = __importDefault(require("../../hooks/useDialog"));
/**
 * @deprecated The DialogContainer has been deprecated and will be removed in a
 * future breaking change. Please use the Overlay component instead.
 */


const DialogContainer = _a => {
  var {
    visible,
    portal,
    children
  } = _a,
      props = __rest(_a, ["visible", "portal", "children"]);

  const dialogColumn = react_1.useRef();
  const {
    closeDialog
  } = useDialog_1.default();
  return react_1.default.createElement(Portal_1.default, {
    portal: portal
  }, react_1.default.createElement(DialogColumn, Object.assign({}, props, {
    ref: dialogColumn,
    onClick: event => {
      if (event.target === dialogColumn.current) {
        closeDialog();
      }
    }
  }), visible && children));
};

exports.default = DialogContainer;
const DialogColumn = styled_components_1.default(Column_1.default).attrs({
  mainAxisAlignment: 'center',
  crossAxisAlignment: 'center'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 32px;\n  background: ", ";\n  pointer-events: ", ";\n"])), props => props.children && 'rgba(0, 0, 0, 0.1)', props => !props.children && 'none');